import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUser, setToken } from '../Slices/auth';
import { useFormik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ReactLoading from 'react-loading';
import { registerSchema } from '../schemas';
import toast from 'react-hot-toast';
import mode from './Mode';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextField from '@mui/material/TextField';
import '../styles/auth.css';
import Toast from './Toaster';

const Register = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [formMessage, setFormMessage] = useState({ type: '', text: '' });
    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/general/' : 'http://127.0.0.1:8000/general/';
    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const onSubmit = () => {
        setIsLoading(true);
        setFormMessage({ type: '', text: '' });
        axios.post(baseurl + 'register/', {
            username: values.email,
            email: values.email,
            password: values.password1,
        }).then((response) => {
            dispatch(setUser(response.data.user));
            dispatch(setToken(response.data.token));
            toast.success('Successful Registration', {
                position: 'bottom-left',
                duration: 3000
            });
            setTimeout(() => { navigate('/member-register') }, 3000);
        }).catch((error) => {
            setIsLoading(false);
            if (error.response && error.response.data && error.response.data.Error) {
                setFormMessage({ type: 'error', text: error.response.data.Error });
            } else {
                setFormMessage({ type: 'error', text: 'An error occurred. Please try again.' });
            }
        });
    };

    const { values, errors, handleBlur, touched, handleChange, handleSubmit } = useFormik({
        initialValues: {
            email: '',
            password1: '',
            password2: ''
        },
        validationSchema: registerSchema,
        onSubmit
    });

    return (
        <div className='auth-container'>
            <Toast />
            <div className="auth-wrapper">
                <div className="auth-header">
                    <h1>Student Register</h1>
                    <p>Create your account to get started.</p>
                </div>

                <form method="POST" className='auth-form' onSubmit={handleSubmit}>
                    {formMessage.text && (
                        <div className={`form-message ${formMessage.type}`}>
                            {formMessage.text}
                        </div>
                    )}
                    <div className='form-group'>
                        <label htmlFor="email">Email Address</label>
                        <TextField
                            fullWidth
                            required
                            error={!!(errors.email && touched.email)}
                            id="email"
                            variant="outlined"
                            name='email'
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                        />
                        {errors.email && touched.email && <p className='error-text'>{errors.email}</p>}
                    </div>
                    <div className='form-group'>
                        <label htmlFor="password">Password</label>
                        <TextField
                            fullWidth
                            required
                            error={!!(errors.password1 && touched.password1)}
                            id="password"
                            variant="outlined"
                            name='password1'
                            type={showPassword ? 'text' : 'password'}
                            value={values.password1}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        {errors.password1 && touched.password1 && <p className='error-text'>{errors.password1}</p>}
                    </div>
                    <div className='form-group'>
                        <label htmlFor="confirm-password">Confirm Password</label>
                        <TextField
                            fullWidth
                            required
                            error={!!(errors.password2 && touched.password2)}
                            id="confirm-password"
                            variant="outlined"
                            name='password2'
                            type={showPassword ? 'text' : 'password'}
                            value={values.password2}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                        />
                        {errors.password2 && touched.password2 && <p className='error-text'>{errors.password2}</p>}
                    </div>

                    <button className="auth-btn" type="submit" disabled={isLoading}>
                        {isLoading ? <ReactLoading type="spin" color="#fff" height={25} width={25} /> : "Register"}
                    </button>
                </form>
                <div className="auth-footer">
                    <small className="text-muted">
                        Already have an account? <Link to='/Login'>Login</Link>
                    </small>
                </div>
            </div>
        </div>
    );
}

export default Register;